import {Button} from "../../components/ui/button";
import {ArrowLeftIcon} from "lucide-react";
import {useNavigate} from "react-router-dom";

export function ImprintPage() {
    const navigate = useNavigate();
    return <div className={"flex flex-col items-center justify-center min-h-[100svh]"}>
        <div className={"max-w-[85svw] flex flex-row gap-10 flex-wrap"}>
            <div className={"flex flex-col gap-5"}>
                <h2 className={"-mt-1 italic"}>Impressum</h2>
                <Button onClick={() => navigate(-1)} variant={"outline-primary"} className={"self-start group"}>
                    <ArrowLeftIcon className={"w-5 h-5 group-hover:-translate-x-1 transition-all duration-300"} />
                    <div className={"group-hover:-translate-x-0.5 transition-all duration-500"}>Back</div>
                </Button>
            </div>
            <div className={"flex flex-col gap-3"}>
                <h4>Thinkin' Apps Moritz Bruder</h4>
                <div className={"grid grid-cols-[auto,auto] gap-x-1 gap-y-2"}>
                    <div>E-Mail</div>
                    <div><a href="mailto:info@thinkin-apps.de">info@thinkin-apps.de</a></div>
                    <div>Steuer-ID.</div>
                    <div>94 721 685 702</div>
                    <div>Adresse</div>
                    <div>Wildenbruchstrasse 61<br/>60431 Frankfurt am Main</div>
                </div>
                <p className={"text-sm"}> Verantwortlich im Sinne des &sect;5 TMG: <b>Moritz Bruder</b></p>
            </div>
        </div>
    </div>
}